<template>
    <span class="user-tag">
        <a-avatar :src="user.avatar" shape="square"/>
        <a :href="link" target="_blank">{{ user.name }}</a>
    </span>
</template>

<script>
export default {
    props: {
        'user': {}
    },
    computed: {
        link: function() {
            return '/user/?id=' + this.user.id;
        }
    }
}
</script>

<style>

</style>